import deepmerge from "deepmerge";
import * as uiActions from "./uiActions";
import combineMerge from "config/combineMerge";
import { produce } from "immer";

const initialState = {
  byId: {},
  allIds: [],
  folder_id: 0,
  hasMore: false
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case uiActions.FETCH_DOCUMENTS_PENDING: {
      const { folder_id, isStart } = action.payload || {};
      if (isStart && draft.folder_id !== folder_id) {
        draft.allIds = [];
        draft.hasMore = false;
        draft.folder_id = folder_id;
      }
      break;
    }

    case uiActions.FETCH_DOCUMENTS_SUCCESS: {
      const allIds = action.payload.documents.map(message => message.id);
      const byId = action.payload.documents.reduce((obj, message) => {
        obj[message.id] = {
          ...message
        };
        return obj;
      }, {});

      if (draft.folder_id !== action.payload.folder_id) {
        draft.byId = byId;
        draft.folder_id = action.payload.folder_id;
      } else {
        draft.byId = deepmerge(draft.byId, byId, {
          arrayMerge: combineMerge
        });
      }

      draft.hasMore = action.payload.hasMore;

      if (action.payload.isStart) {
        draft.allIds = allIds;
      } else {
        draft.allIds = deepmerge(draft.allIds, allIds, {
          arrayMerge: combineMerge
        });
      }
      break;
    }

    case uiActions.RESET_DOCUMENTS: {
      draft.byId = {};
      draft.allIds = [];
      draft.folder_id = 0;
      draft.hasMore = false;
      break;
    }

    case uiActions.ADD_DOCUMENT: {
      const { payload } = action;
      draft.byId[payload.id] = payload;
      if (draft.allIds.indexOf(payload.id) < 0) {
        draft.allIds.push(payload.id);
      }
      break;
    }

    case uiActions.UPDATE_DOCUMENT: {
      const { payload } = action;
      draft.byId[payload.id] = payload;
      break;
    }

    case uiActions.UPDATE_PROGRESS: {
      const { payload } = action;
      draft.byId[payload.fileId].progress = payload.newProgress;
      break;
    }

    case uiActions.REMOVE_DOCUMENT: {
      const { payload } = action;
      draft.allIds = draft.allIds.filter(item => !payload.includes(item));
      break;
    }

    case uiActions.DELETE_DOCUMENT_SUCCESS:
      const { payload } = action;
      draft.allIds = draft.allIds.filter(item => !payload.includes(item));
      break;

    default:
      return draft;
  }
}, initialState);

export default reducer;
